<template>
  <div class="topic">
    <div class="code" v-if="mainConfig.AppUrl">
      <img src="https://img2.233.com/wx/union/pure/pc/blue/tkewm_ic.png" v-if="skinColor === 'blue'">
      <img src="https://img2.233.com/wx/union/pure/pc/green/tkewm_ic.png" v-else-if="skinColor === 'green'">
      <img src="https://img2.233.com/wx/union/pure/pc/red/tkewm_ic.png" v-else>
      <div class="qrcode">
        <span ref="qrcodeFinal"></span>
        <p>扫二维码立即做题</p>
      </div>
    </div>
    <div class="title">
      <h3>在线题库</h3>
      <span v-if="mainConfig.AppUrl">手机刷题</span>
    </div>
    <div class="item" v-for="item in 4" :key="item">
      <div class="left">
        <template v-if="item === 1">
          <img src="https://img2.233.com/wx/union/pure/pc/blue/tk_ic_4.png" class="delegate" v-if="skinColor === 'blue'">
          <img src="https://img2.233.com/wx/union/pure/pc/green/tk_ic_4.png" class="delegate" v-else-if="skinColor === 'green'">
          <img src="https://img2.233.com/wx/union/pure/pc/red/tk_ic_4.png" class="delegate" v-else>
        </template>
        <template v-if="item === 2">
          <img src="https://img2.233.com/wx/union/pure/pc/blue/tk_ic_3.png" class="delegate" v-if="skinColor === 'blue'">
          <img src="https://img2.233.com/wx/union/pure/pc/green/tk_ic_3.png" class="delegate" v-else-if="skinColor === 'green'">
          <img src="https://img2.233.com/wx/union/pure/pc/red/tk_ic_3.png" class="delegate" v-else>
        </template>
        <template v-if="item === 3">
          <img src="https://img2.233.com/wx/union/pure/pc/blue/tk_ic_1.png" class="delegate" v-if="skinColor === 'blue'">
          <img src="https://img2.233.com/wx/union/pure/pc/green/tk_ic_1.png" class="delegate" v-else-if="skinColor === 'green'">
          <img src="https://img2.233.com/wx/union/pure/pc/red/tk_ic_1.png" class="delegate" v-else>
        </template>
        <template v-if="item === 4">
          <img src="https://img2.233.com/wx/union/pure/pc/blue/tk_ic_2.png" class="delegate" v-if="skinColor === 'blue'">
          <img src="https://img2.233.com/wx/union/pure/pc/green/tk_ic_2.png" class="delegate" v-else-if="skinColor === 'green'">
          <img src="https://img2.233.com/wx/union/pure/pc/red/tk_ic_2.png" class="delegate" v-else>
        </template>
        <div class="text">
          <p>{{["章节练习", "历年真题", "全真机考", "模拟试卷"][item - 1]}}</p>
          <span>{{["章节专享突破", "真题实战演练", "海量试题免费做", "全真模拟实战"][item - 1]}}</span>
        </div>
      </div>
      <div class="button" @click="$emit('openLink', [3, 5, 6, 6][item - 1])">
        <div class="button-bg">
          <img src="https://img2.233.com/wx/union/pure/pc/tk_ic_0.png">
          <span>做题</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qrcode from 'qrcodejs2'
export default {
  name: "Topic",
  props: {
    mainConfig: {
      type: Object,
      default: () => {}
    },
    skinColor: {
      type: String,
      default: ""
    }
  },
  mounted() {
    this.mainConfig.AppUrl && new qrcode(this.$refs.qrcodeFinal, {
      text: this.mainConfig.AppUrl,
      width: 123,
      height: 123,
      colorDark: '#000',
      colorLight: '#fff'
    })
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../assets/css/index.scss";
.topic{
  width: 274px;
  height: 100%;
  background: #FFFFFF;
  box-shadow: 1px 15px 18px 1px rgba(0, 0, 0, 0.02);
  padding: 31px 0 0 19px;
  position: relative;
  box-sizing: border-box;
  &::before{
    content: "";
    position: absolute;
    top: 0;
    left: 19px;
    width: 40px;
    height: 2px;
    @include recommend_topic_background();
  }
  .code{
    position: absolute;
    top: 0;
    right: 0;
    width: 37px;
    height: 36px;
    &:hover{
      .qrcode{
        display: inline-block;
      }
    }
    img{
      width: 100%;
      height: 100%;
      vertical-align: top;
    }
    .qrcode{
      display: none;
      position: absolute;
      top: 54px;
      left: -106px;
      padding: 10px;
      background: #fff;
      box-shadow: 1px 8px 45px 2px rgba(0, 0, 0, 0.14);
      img{
        width: 123px;
        height: 123px;
      }
      p{
        text-align: center;
        line-height: 14px;
        font-size: 14px;
        color: #343434;
        font-weight: 400;
        margin-top: 5px;
      }
    }
  }
  .title{
    display: flex;
    justify-content: space-between;
    h3{
      color: #343434;
      font-size: 20px;
      font-weight: 400;
      line-height: 20px;
    }
    span{
      color: #565656;
      font-size: 14px;
      font-weight: 400;
      margin: 6px 17px 0 0;
      line-height: 14px;
    }
  }
  .item{
    display: flex;
    justify-content: space-between;
    padding: 27px 0 14px;
    .left{
      display: flex;
      .delegate{
        width: 41px;
        height: 41px;
        margin-right: 10px;
      }
      .text{
        p{
          font-size: 15px;
          color: #343434;
          font-weight: 400;
          line-height: 21px;
        }
        span{
          font-size: 12px;
          font-weight: 400;
          color: #565656;
          line-height: 14px;
        }
      }
    }
    .button{
      width: 85px;
      height: 43px;
      background: #FFF6F5;
      border-top-left-radius: 22px;
      border-bottom-left-radius: 22px;
      cursor: pointer;
      transition: .2s;
      &:hover{
        box-shadow: 0px 1px 18px rgba(0, 0, 0, .2);
      }
      .button-bg{
        margin: 6px 0 0 7px;
        width: 78px;
        height: 30px;
        line-height: 30px;
        @include recommend_topic_button_background();
        border-top-left-radius: 15px;
        border-bottom-left-radius: 15px;
        text-align: center;
        img{
          width: 15px;
          height: 15px;
          vertical-align: middle;
        }
        span{
          color: #fff;
          font-size: 15px;
          font-weight: 400;
          margin-left: 6px;
        }
      }
    }
  }
}
</style>